// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import { Pulse as SpotlightPulse } from '@atlaskit/onboarding/target';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import { Text } from '@atlaskit/primitives/compiled/text';

import { type PropsWithChildren, useCallback, useState } from 'react';

import { useIntl } from 'react-intl';

import messages from './messages';

import { type JSX } from 'react/jsx-runtime';

import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';

import { SpotlightHeadline } from '@atlaskit/spotlight/headline';

import { SpotlightHeader } from '@atlaskit/spotlight/header';

import { SpotlightFooter } from '@atlaskit/spotlight/footer';

import { SpotlightDismissControl } from '@atlaskit/spotlight/dismiss-control';

import { SpotlightControls } from '@atlaskit/spotlight/controls';

import { SpotlightCard } from '@atlaskit/spotlight/card';

import { SpotlightBody } from '@atlaskit/spotlight/body';

import { SpotlightActions } from '@atlaskit/spotlight/actions';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

import { PopoverContent } from '@atlaskit/spotlight/popover-content';

export const FilterRefinementSpotlightCard = ({ children }: PropsWithChildren): JSX.Element => {
	const { formatMessage } = useIntl();
	const [isSpotlightActive, setIsSpotlightActive] = useState<boolean>(true);

	const { onAcknowledged, onClosed } = usePostOfficeUserInteractions();

	// The X (and click-away) expresses no choice, so it is a close.
	const onDismiss = useCallback(() => {
		setIsSpotlightActive(false);

		void onClosed({ interactionIdentifier: 'dismiss' });
	}, [onClosed]);

	// An informational card with no actionable ask, so "OK" acknowledges it.
	const onDone = useCallback(() => {
		setIsSpotlightActive(false);

		void onAcknowledged({ interactionIdentifier: 'done' });
	}, [onAcknowledged]);

	return (
		<PopoverProvider>
			<PopoverTarget>
				<SpotlightPulse radius={3} pulse={isSpotlightActive}>
					{children}
				</SpotlightPulse>
			</PopoverTarget>
			<PopoverContent dismiss={onDismiss} placement="left-end" isVisible={isSpotlightActive}>
				<SpotlightCard>
					<SpotlightHeader>
						<SpotlightHeadline>{formatMessage(messages.changeboardingTitle)}</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl onClick={onDismiss} />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightBody>
						<Stack space="space.150">
							<Text>{formatMessage(messages.changeboardingText)}</Text>
							<Text>{formatMessage(messages.changeboardingTextAdvancedJQL)}</Text>
						</Stack>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={onDone}>
								{formatMessage(messages.changeboardingOkButton)}
							</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
